import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { FgiBackEndService } from 'src/app/shared/fgi-back-end.service';
import { ResultadoPaginado } from 'src/app/model/resultado';
import { RecuperacaoCredito, ResultadoCalculoValorHonradoARecuperar } from 'src/app/model/recuperacao-credito.model';
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { ResolucaoInconsistenciaRecuperacaoCredito } from '../../../model/recuperacao-credito.model';

@Injectable({
  providedIn: 'root'
})
export class RecuperacaoCreditoService extends FgiBackEndService<RecuperacaoCredito> {

    // @Override
  getNewEntity() {
    const novo = new RecuperacaoCredito();
    novo.dataEnvio = new Date();
    return novo;
  }

  // @Override
  protected getResourceURL(): string {
    return 'front/recuperacoes-credito';
  }

  // nao tem no BaseEntityService pra fazer override
  getRecuperacaoCredito(id): Observable<RecuperacaoCredito> {
    return this.http.get(`${this.BASE_URL}/${id}`).pipe(
      catchError((e) => this.handleError(e))) as Observable<RecuperacaoCredito>;
  }

  // nao tem no BaseEntityService pra fazer override
  getRecuperacoesCredito(params?: any): any {
    return this.http.get(`${this.BASE_URL}`, {params: params}).pipe(
      catchError((e) => this.handleError(e))) as Observable<Array<RecuperacaoCredito>>;
  }

  // nao tem no BaseEntityService pra fazer override
  getRecuperacoesCreditoInconsistentesPorTipo(tipoInconsistencia, pagina, limite, somenteResolvidas): Observable<ResultadoPaginado<RecuperacaoCredito>> {
    const options: any = blockUi();
    options.params.tipoInconsistencia = tipoInconsistencia;
    options.params.pagina = pagina;
    options.params.limite = limite;
    if (somenteResolvidas != undefined) {
      options.params.somenteResolvidas = somenteResolvidas;
    }
    return this.http.get(`${this.BASE_URL}/recuperacoes-inconsistentes`, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<ResultadoPaginado<RecuperacaoCredito>>;
  }

  cancelar (id: number, motivo: string): Observable<RecuperacaoCredito> {
    return this.http.post(`${this.BASE_URL}/${id}/cancelar?motivo=` + motivo, {}).pipe(
      catchError((e) => this.handleError(e))) as Observable<RecuperacaoCredito>;
  }

  protocolar(json: any, apenasValidar: boolean): Observable<any> {
    const options: any = blockUi();
    options.params.apenasValidacao = apenasValidar;
    return this.http.post(`${this.BASE_URL}/protocolar`, json, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<any>;
  }

  calcularValorHonradoRecuperar(params?: any): Observable<ResultadoCalculoValorHonradoARecuperar> {
    let options: any = blockUi();
    options.params = params;
    return this.http.get(`${this.BASE_URL}/calcular-valor-honrado-recuperar`, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<ResultadoCalculoValorHonradoARecuperar>;
  }

  salvarResolucaoPendencia(dto: ResolucaoInconsistenciaRecuperacaoCredito): Observable<ResolucaoInconsistenciaRecuperacaoCredito> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/resolucao-recuperacao-inconsistente`, dto, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<ResolucaoInconsistenciaRecuperacaoCredito>;
  }

  atualizarEstorno(id, estorno): Observable<RecuperacaoCredito> {
    return this.http.post(`${this.BASE_URL}/${id}/atualizar-estorno-manual?estorno=${estorno}`, {}).pipe(
      catchError((e) => this.handleError(e))) as Observable<RecuperacaoCredito>;
  }
}
